import React, { useState } from 'react';
import styles from './addCategoryModal.module.css';
import { useSelector } from 'react-redux';
import { addNewCategory } from '../../Api/Ecom';
import { toast } from 'react-toastify';

function AddCategoryModal({ openModal, closeModal, updateData }) {
  const [data, setData] = useState({
    name: '',
    img: null
  });
  const token = useSelector(state => state.login.token);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setData(prev => ({ ...prev, img: file }));
    } else {
      console.log('No file selected');
    }
  };

  const handleSave = async () => {
    console.log("Saving category...");
    try {
      if (!data.name || !data.name.trim()) {
        toast.error('Please enter a category name');
        return;
      }

      if (!data.img) {
        toast.error('Please select an image');
        return;
      }

      const response = await addNewCategory(token, data);
      if (response.message === 'success') {
        console.log("Category added successfully");
        updateData();
        console.log("Closing modal...");
        closeModal(); // Add console log to check if it's being executed
        toast.success('New Category Successfully Added');
        setData({ name: '', img: ''});
    
      }else{
        toast.error('Failed to add category');
      } 
    } catch (error) {
      console.error("Error adding category:", error);
        } 
  };

  if (!openModal) return null;

  return (
    <div className={styles.modalOverlay} onClick={closeModal}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.profile}>
          <p>Add Category</p>
          <button className={styles.modalClose} onClick={closeModal}>X</button>
        </div>

        <div className={styles.availUnit}>
          <label>Name</label>
          <input
            type="text"
            value={data.name || ''}
            onChange={handleChange}
            name="name"
            required
          />
          <div>
            {data.img && (
              <img
                src={URL.createObjectURL(data.img)}
                alt="Category Preview"
                 accept="image/*"
                  capture="environment"
                style={{ maxWidth: '200px', marginTop: '10px' }}
              />
            )}
            <input 
              type="file" 
              onChange={handleImageChange}
              accept="image/*"
              style={{border: 'none'}}
            />
          </div>
        </div>

        <div className={styles.saveCancel}>
          <button className={styles.cancel} onClick={closeModal}>
         Cancel
          </button>
          <button className={styles.save} onClick={handleSave}>
             Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddCategoryModal;
